// ===============================================
// Column header order to be displayed in table
// - key is stat key in game data dict, value is header that will be shown in table
// - header order map is list mapping results field name to column name in order they should appear in table
// ===============================================

const TURNOVERS_KEY = 'Turnovers'
const PENALTY_KEY = 'Penalty'

const DATE_STRING = 'Date'
const SEASON_STRING = 'Season'
const MINUTES_STRING = 'Minutes'
const NAME_STRING = 'Name'
const PLUS_MINUS_STRING = 'PlusMinus'
const OFFENSIVE_POSSESSION_STRING = 'OffPoss'
const ASSISTED_STRING = 'Assisted'
const UNASSISTED_STRING = 'Unassisted'
const TWOS_STRING = '2s'
const PCT_STRING = 'Pct'
const THREES_STRING = '3s'
const BLOCKED_STRING = 'Blocked'
const ASSISTS_STRING = 'Assists'
const AT_RIM_STRING = 'AtRim'
const SHORT_MID_RANGE_STRING = 'ShortMidRange'
const LONG_MID_RANGE_STRING = 'LongMidRange'
const CORNER_3_STRING = 'Corner3'
const ARC_3_STRING = 'Arc3'
const REBOUNDS_STRING = 'Rebounds'
const DEFENSIVE_ABBREVIATION_PREFIX = 'Def'
const FREE_THROW_STRING = 'FT'
const OFFENSIVE_ABBREVIATION_PREFIX = 'Off'
const SELF_REBOUND_STRING = 'SelfOReb'
const LIVEBALL_TURNOVERS_STRING = 'LiveBallTurnovers'
const DEADBALL_TURNOVERS_STRING = 'DeadBallTurnovers'
const SECOND_CHANCE_STRING = 'SecondChance'
const LOST_BALL_TURNOVER_STRING = 'LostBallTurnovers'
const LOST_BALL_OUT_OF_BOUNDS_TURNOVER_STRING = 'LostBallOutOfBoundsTurnovers'
const BAD_PASS_TURNOVER_STRING = 'BadPassTurnovers'
const BAD_PASS_OUT_OF_BOUNDS_TURNOVER_STRING = 'BadPassOutOfBoundsTurnovers'
const TRAVELS_STRING = 'Travels'
const THREE_SECOND_VIOLATION_TURNOVER_STRING = '3SecondViolations'
const STEP_OUT_OF_BOUNDS_TURNOVER_STRING = 'StepOutOfBoundsTurnovers'
const OFFENSIVE_GOALTENDING_STRING = 'OffensiveGoaltends'
const FOULS_DRAWN_TYPE_STRING = ' Drawn'
const LOOSE_BALL_FOUL_TYPE_STRING = 'Loose Ball Fouls'
const OFFENSIVE_FOUL_TYPE_STRING = 'Offensive Fouls'
const CHARGE_FOUL_TYPE_STRING = 'Charge Fouls'
const CLEAR_PATH_FOUL_TYPE_STRING = 'Clear Path Fouls'
const TRANSITION_TAKE_TYPE_STRING = 'Transition Take Fouls'
const DEFENSIVE_3_SECONDS_FOUL_TYPE_STRING = 'Defensive 3 Seconds Violations'
const TECHNICAL_FREE_THROW_STRING = 'Technical Free Throw Trips'
const TWO_POINT_AND1_FREE_THROW_STRING = '2pt And 1 Free Throw Trips'
const THREE_POINT_AND1_FREE_THROW_STRING = '3pt And 1 Free Throw Trips'
const STEALS_STRING = 'Steals'
const LOST_BALL_STEAL_STRING = 'LostBallSteals'
const BAD_PASS_STEAL_STRING = 'BadPassSteals'
const DEFENSIVE_GOALTENDING_STRING = 'DefensiveGoaltends'
const REBOUNDED_STRING = 'Rebounded'
const HEAVE_MAKES_STRING = 'HeaveMakes'
const PENALTY_POSSESSIONS_EXCLUDING_TAKE_FOUL_FTS = 'PenaltyOffPossExcludingTakeFouls'
const DEFENSIVE_POSSESSION_STRING = 'DefPoss'
const GAMES_PLAYED_KEY = 'GamesPlayed'
const TEAM_ABBREVIATION_STRING = 'TeamAbbreviation'
const OPPONENT_STRING = 'Opponent'
const TEAM_STRING = 'Team'
const SHORT_NAME_STRING = 'ShortName'
const USAGE_STRING = 'Usage'
const POINTS_STRING = 'Points'
const FG2M_STRING = 'FG2M'
const FG2A_STRING = 'FG2A'
const FG2_PCT_STRING = 'Fg2Pct'
const FG3M_STRING = 'FG3M'
const FG3A_STRING = 'FG3A'
const FG3_PCT_STRING = 'Fg3Pct'
const NON_HEAVE_FG3_PCT_STRING = 'NonHeaveFg3Pct'
const FT_POINTS_STRING = 'FtPoints'
const ASSISTED_2_POINTS_STRING = 'Pts' + ASSISTED_STRING + TWOS_STRING
const UNASSISTED_2_POINTS_STRING = 'Pts' + UNASSISTED_STRING + TWOS_STRING
const ASSISTED_3_POINTS_STRING = 'Pts' + ASSISTED_STRING + THREES_STRING
const UNASSISTED_3_POINTS_STRING = 'Pts' + UNASSISTED_STRING + THREES_STRING
const REBOUND_STRING = 'Rebound'
const NON_PUTBACKS_STRING = 'NonPutbacks'
const SHOT_QUALITY_AVG_STRING = 'ShotQualityAvg'
const EFG_PCT_STRING = 'EfgPct'
const TS_PCT_STRING = 'TsPct'
const PUTBACK_POINTS_STRING = 'PtsPutbacks'
const TWOS_BLOCKED_STRING = 'Fg2aBlocked'
const THREES_BLOCKED_STRING = 'Fg3aBlocked'
const ASSIST_POINTS_STRING = 'AssistPoints'
const TWO_POINT_ASSISTS_STRING = 'TwoPtAssists'
const THREE_POINT_ASSISTS_STRING = 'ThreePtAssists'
const TWO_POINT_STRING = 'TwoPt'
const THREE_POINT_STRING = 'ThreePt'
const FG_STRING = 'FG'
const LIVE_BALL_TURNOVER_PERCENTAGE_STRING = 'LiveBallTurnoverPct'
const FOULS_STRING = 'Fouls'
const SHOOTING_FOULS_STRING = 'ShootingFouls'
const BLOCKING_FOULS_STRING = 'BlockingFouls'
const DRAWN_STRING = 'Drawn'
const FTA_STRING = 'FTA'
const NON_SHOOTING_STRING = 'NonShooting'
const BLOCKS_STRING = 'Blocks'
const RECOVERED_STRING = 'Recovered'
const ON_STRING = 'On'
const FIRST_CHANCE_STRING = 'FirstChance'
const PACE_STRING = 'Pace'
const SECONDS_STRING = 'Seconds'
const OFF_RTG_STRING = 'OffRtg'
const DEF_RTG_STRING = 'DefRtg'
const PER_POSSESSION_STRING = 'PerPoss'
const EXCLUDING_OREBS_STRING = 'ExcludingORebs'
const AVG_2PT_SHOT_DISTANCE = 'Avg2ptShotDistance'
const AVG_3PT_SHOT_DISTANCE = 'Avg3ptShotDistance'
const UNBLOCKED_STRING = 'Unblocked'
const FGM_STRING = 'FGM'
const FGA_STRING = 'FGA'
const FREQUENCY_STRING = 'Frequency'
const ACCURACY_STRING = 'Accuracy'
const NON_HEAVE_STRING = 'NonHeave'
const HEAVE_ATTEMPTS_STRING = 'HeaveAttempts'
const PENALTY_POINTS_EXCLUDING_TAKE_FOUL_FTS = 'PenaltyPointsExcludingTakeFouls'
const NON_SHOOTING_NON_TAKE_PENALTY_FOULS_DRAWN = 'NonShootingPenaltyNonTakeFoulsDrawn'
const NON_SHOOTING_NON_TAKE_PENALTY_FOULS_COMMITTED = 'NonShootingPenaltyNonTakeFouls'
const OFF_STRING = 'Off'
const NET_RTG_STRING = 'NetRtg'

const MINUTES_HEADER = [{'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number'}]
const MINUTES_HEADER_WITH_MINFILTER = [{'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number', 'minfilter': true}]
const PLUS_MINUS_HEADER = [{'field': PLUS_MINUS_STRING, 'label': 'P/M', 'type': 'number', 'tooltip': 'Plus Minus'}]
const NAME_HEADER = [{'field': NAME_STRING, 'label': 'Name'}]
const FILTERABLE_NAME_HEADER = [{'field': NAME_STRING, 'label': 'Name', 'filterable': true}]
const GAMES_PLAYED_HEADER = [{'field': GAMES_PLAYED_KEY, 'label': 'GP', 'type': 'number'}]
const SEASON_HEADER = [{'field': SEASON_STRING, 'label': 'Season'}]
const TEAM_ABBREVIATION_HEADER = [{'field': TEAM_ABBREVIATION_STRING, 'label': 'Team', 'filterable': true}]
const DEFENSIVE_POSSESSION_HEADER = {'field': DEFENSIVE_POSSESSION_STRING, 'label': 'Possessions', 'type': 'number'}

const TEAM_GAME_LOGS_HEADERS = [
  {'field': DATE_STRING, 'label': 'Date', 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
  {'field': OPPONENT_STRING, 'label': 'Vs'}
]

const PLAYER_GAME_LOGS_HEADERS = [
  {'field': DATE_STRING, 'label': 'Date', 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
  {'field': TEAM_STRING, 'label': 'Team', 'filterable': true},
  {'field': OPPONENT_STRING, 'label': 'Vs', 'filterable': true},
  {'field': MINUTES_STRING, 'label': 'Min'}
]

const LINEUP_GAME_LOGS_HEADERS = [
  {'field': DATE_STRING, 'label': 'Date', 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
  {'field': TEAM_STRING, 'label': 'Team'},
  {'field': OPPONENT_STRING, 'label': 'Vs'},
  {'field': MINUTES_STRING, 'label': 'Min'}
]

// const PLAYER_TOTALS_HEADERS = [
//   {'field': NAME_STRING, 'label': 'Name', 'filterable': true},
//   {'field': TEAM_ABBREVIATION_STRING, 'label': 'Team', 'filterable': true},
//   {'field': GAMES_PLAYED_KEY, 'label': 'GP', 'type': 'number'},
//   {'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number', 'minfilter': true}
// ]

const LINEUP_TOTALS_HEADERS = [
  {'field': SHORT_NAME_STRING, 'label': 'Lineup', 'filterable': true},
  {'field': TEAM_ABBREVIATION_STRING, 'label': 'Team', 'filterable': true},
  {'field': GAMES_PLAYED_KEY, 'label': 'GP', 'type': 'number'},
  {'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number', 'minfilter': true}
]

const LINEUP_TOTALS_NON_FILTERABLE_HEADERS = [
  {'field': SHORT_NAME_STRING, 'label': 'Lineup'},
  {'field': TEAM_ABBREVIATION_STRING, 'label': 'Team'},
  {'field': GAMES_PLAYED_KEY, 'label': 'GP', 'type': 'number'},
  {'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number'}
]

const LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS = [
  {'field': SHORT_NAME_STRING, 'label': 'Lineup', 'filterable': true},
  {'field': TEAM_ABBREVIATION_STRING, 'label': 'Team', 'filterable': true},
  {'field': MINUTES_STRING, 'label': 'Minutes', 'type': 'number', 'minfilter': true}
]

const PLAYER_GAME_HEADERS = [
  {'field': NAME_STRING, 'label': 'Name'},
  {'field': MINUTES_STRING, 'label': 'Min'}
]

const LINEUP_GAME_HEADERS = [
  {'field': SHORT_NAME_STRING, 'label': 'Name'},
  {'field': MINUTES_STRING, 'label': 'Min'}
]

const TOTALS_HEADERS = [
  {'field': TEAM_STRING, 'label': 'Team'},
  {'field': SEASON_STRING, 'label': 'Season'},
  {'field': GAMES_PLAYED_KEY, 'label': 'GP', 'type': 'number'},
  {'field': MINUTES_STRING, 'label': 'Min', 'type': 'number'}
]

const SCORING_PLAYER_ONLY_HEADERS = [
  {'field': USAGE_STRING, 'label': 'Usage', 'type': 'decimal', 'minfilter': true}
]

const SCORING_HEADERS = [
  {'field': OFFENSIVE_POSSESSION_STRING, 'label': 'Possessions', 'type': 'number'},
  {'field': POINTS_STRING, 'label': 'Pts', 'type': 'number'},
  {'field': FG2M_STRING, 'label': 'FG2M', 'type': 'number'},
  {'field': FG2A_STRING, 'label': 'FG2A', 'type': 'number', 'minfilter': true},
  {'field': FG2_PCT_STRING, 'label': '2pt FG%', 'type': 'percentage'},
  {'field': FG3M_STRING, 'label': 'FG3M', 'type': 'number'},
  {'field': FG3A_STRING, 'label': 'FG3A', 'type': 'number', 'minfilter': true},
  {'field': FG3_PCT_STRING, 'label': '3pt FG%', 'type': 'percentage'},
  {'field': NON_HEAVE_FG3_PCT_STRING, 'label': 'Non-Heave 3pt FG%', 'type': 'percentage', 'tooltip': 'Heaves are defined as 40+ feet with <2 seconds remaining'},
  {'field': FT_POINTS_STRING, 'label': 'FT Pts', 'type': 'number'},
  {'field': ASSISTED_2_POINTS_STRING, 'label': 'AST2 Pts', 'type': 'number', 'tooltip': 'Points on Assisted 2s'},
  {'field': UNASSISTED_2_POINTS_STRING, 'label': 'UAST2 2s Pts', 'type': 'number', 'tooltip': 'Points on Unassisted 2s'},
  {'field': ASSISTED_3_POINTS_STRING, 'label': 'AST3 Pts', 'type': 'number', 'tooltip': 'Points on Assisted 3s'},
  {'field': UNASSISTED_3_POINTS_STRING, 'label': 'UAST3 Pts', 'type': 'number', 'tooltip': 'Points on Unassisted 3s'},
  {'field': ASSISTED_STRING + TWOS_STRING + PCT_STRING, 'label': '2pt AST%', 'type': 'percentage', 'tooltip': '2pt FGM Assist%'},
  {'field': NON_PUTBACKS_STRING + ASSISTED_STRING + TWOS_STRING + PCT_STRING, 'label': 'Non Putback 2pt AST%', 'type': 'percentage', 'tooltip': '2pt FGM Assist% excluding putbacks'},
  {'field': ASSISTED_STRING + THREES_STRING + PCT_STRING, 'label': '3pt AST%', 'type': 'percentage', 'tooltip': '3pt FGM Assist%'},
  {'field': FG3A_STRING + PCT_STRING, 'label': '3PAr', 'type': 'percentage', 'tooltip': '3 Point Attempt Rate'},
  {'field': SHOT_QUALITY_AVG_STRING, 'label': 'Shot Quality', 'type': 'decimal', 'tooltip': 'Expected eFG model based on location and play context. See link on homepage for more details'},
  {'field': EFG_PCT_STRING, 'label': 'eFG%', 'type': 'percentage'},
  {'field': TS_PCT_STRING, 'label': 'TS%', 'type': 'percentage'},
  {'field': PUTBACK_POINTS_STRING, 'label': 'PUT', 'type': 'number', 'tooltip': 'Putback Points'},
  {'field': TWOS_BLOCKED_STRING, 'label': 'FG2AB', 'type': 'number', 'tooltip': 'FG2A Blocked'},
  {'field': FG2A_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of FG2AB', 'type': 'percentage', 'tooltip': '% of FG2A Blocked'},
  {'field': THREES_BLOCKED_STRING, 'label': 'FG3AB', 'type': 'number', 'tooltip': 'FG3A Blocked'},
  {'field': FG3A_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of FG3AB', 'type': 'percentage', 'tooltip': '% of FG3A Blocked'}
]

const ASSISTS_HEADERS = [
  {'field': ASSISTS_STRING, 'label': 'Assists', 'type': 'number'},
  {'field': ASSIST_POINTS_STRING, 'label': 'Assist Pts', 'type': 'number'},
  {'field': TWO_POINT_ASSISTS_STRING, 'label': '2pt', 'type': 'number'},
  {'field': THREE_POINT_ASSISTS_STRING, 'label': '3pt', 'type': 'number'},
  {'field': AT_RIM_STRING + ASSISTS_STRING, 'label': 'At Rim', 'type': 'number'},
  {'field': SHORT_MID_RANGE_STRING + ASSISTS_STRING, 'label': 'SMR', 'type': 'number', 'tooltip': 'Short Mid-Range (4-14ft)'},
  {'field': LONG_MID_RANGE_STRING + ASSISTS_STRING, 'label': 'LMR', 'type': 'number', 'tooltip': 'Long Mid-Range (14ft - 3pt line)'},
  {'field': CORNER_3_STRING + ASSISTS_STRING, 'label': 'C3', 'type': 'number', 'tooltip': 'Corner 3'},
  {'field': ARC_3_STRING + ASSISTS_STRING, 'label': 'AB3', 'type': 'number', 'tooltip': 'Above the Break 3'}
]

const REBOUNDS_HEADERS = [
  {'field': REBOUNDS_STRING, 'label': 'Reb', 'type': 'number'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + REBOUNDS_STRING, 'label': 'DReb', 'type': 'number', 'minfilter': true},
  {'field': FREE_THROW_STRING + DEFENSIVE_ABBREVIATION_PREFIX + REBOUNDS_STRING, 'label': 'FT DReb', 'type': 'number'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'label': 'FT DReb%', 'type': 'percentage'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUNDS_STRING, 'label': '2Pt DReb', 'type': 'number'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'label': '2Pt DReb%', 'type': 'percentage'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUNDS_STRING, 'label': '3Pt DReb', 'type': 'number'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'label': '3Pt DReb%', 'type': 'percentage'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'label': 'FG DReb%', 'type': 'percentage'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDS_STRING, 'label': 'OReb', 'type': 'number', 'minfilter': true},
  {'field': FREE_THROW_STRING + OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDS_STRING, 'label': 'FT OReb', 'type': 'number'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + FREE_THROW_STRING + REBOUND_STRING + PCT_STRING, 'label': 'FT OReb%', 'type': 'percentage'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUNDS_STRING, 'label': '2Pt OReb', 'type': 'number'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + TWO_POINT_STRING + REBOUND_STRING + PCT_STRING, 'label': '2Pt OReb%', 'type': 'percentage'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUNDS_STRING, 'label': '3Pt OReb', 'type': 'number'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + THREE_POINT_STRING + REBOUND_STRING + PCT_STRING, 'label': '3Pt OReb%', 'type': 'percentage'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + FG_STRING + REBOUND_STRING + PCT_STRING, 'label': 'FG OReb%', 'type': 'percentage'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'label': 'Rim DReb%', 'type': 'percentage', 'tooltip': 'At Rim DReb%'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'label': 'SMR DReb%', 'type': 'percentage', 'tooltip': 'Short Mid-Range (4-14ft) DReb%'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'label': 'LMR DReb%', 'type': 'percentage', 'tooltip': 'Long Mid-Range (14ft - 3pt line) DReb%'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'label': 'AB3 DReb%', 'type': 'percentage', 'tooltip': 'Above the Break 3 DReb%'},
  {'field': DEFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'label': 'C3 DReb%', 'type': 'percentage', 'tooltip': 'Corner 3 DReb%'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + AT_RIM_STRING + REBOUND_STRING + PCT_STRING, 'label': 'Rim OReb%', 'type': 'percentage', 'tooltip': 'At Rim OReb%'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + SHORT_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'label': 'SMR OReb%', 'type': 'percentage', 'tooltip': 'Short Mid-Range (4-14ft) OReb%'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + LONG_MID_RANGE_STRING + REBOUND_STRING + PCT_STRING, 'label': 'LMR OReb%', 'type': 'percentage', 'tooltip': 'Long Mid-Range (14ft - 3pt line) OReb%'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + ARC_3_STRING + REBOUND_STRING + PCT_STRING, 'label': 'AB3 OReb%', 'type': 'percentage', 'tooltip': 'Above the Break 3 OReb%'},
  {'field': OFFENSIVE_ABBREVIATION_PREFIX + CORNER_3_STRING + REBOUND_STRING + PCT_STRING, 'label': 'C3 OReb%', 'type': 'percentage', 'tooltip': 'Corner 3 OReb%'},
  {'field': SELF_REBOUND_STRING, 'label': 'Z-Bounds', 'type': 'number', 'tooltip': "Offensive Rebounds off a player's own unblocked missed FG"},
  {'field': SELF_REBOUND_STRING + PCT_STRING, 'label': 'Z-Bound Pct', 'type': 'percentage', 'tooltip': "Percentage of a player's unblocked missed FG that they rebound themselves"}
]

const TURNOVERS_HEADERS = [
  {'field': TURNOVERS_KEY, 'label': 'TOs', 'type': 'number'},
  {'field': LIVEBALL_TURNOVERS_STRING, 'label': 'Live Ball TOs', 'type': 'number'},
  {'field': DEADBALL_TURNOVERS_STRING, 'label': 'Dead Ball TOs', 'type': 'number'},
  {'field': LIVE_BALL_TURNOVER_PERCENTAGE_STRING, 'label': 'Live Ball TO%', 'type': 'percentage'},
  {'field': LOST_BALL_TURNOVER_STRING, 'label': 'Lost Ball', 'type': 'number'},
  {'field': LOST_BALL_OUT_OF_BOUNDS_TURNOVER_STRING, 'label': 'Lost Ball Out of Bounds', 'type': 'number'},
  {'field': BAD_PASS_TURNOVER_STRING, 'label': 'Bad Pass', 'type': 'number'},
  {'field': BAD_PASS_OUT_OF_BOUNDS_TURNOVER_STRING, 'label': 'Bad Pass Out of Bounds', 'type': 'number'},
  {'field': TRAVELS_STRING, 'label': 'Travels', 'type': 'number'},
  {'field': THREE_SECOND_VIOLATION_TURNOVER_STRING, 'label': '3 Second Violation', 'type': 'number'},
  {'field': STEP_OUT_OF_BOUNDS_TURNOVER_STRING, 'label': 'Step Out of Bounds', 'type': 'number'},
  {'field': OFFENSIVE_GOALTENDING_STRING, 'label': 'Offensive Goaltending', 'type': 'number'}
]

const FOULS_HEADERS = [
  {'field': FOULS_STRING, 'label': 'Fouls', 'type': 'number'},
  {'field': SHOOTING_FOULS_STRING, 'label': 'SFC', 'type': 'number', 'tooltip': 'Shooting Fouls Committed'},
  {'field': LOOSE_BALL_FOUL_TYPE_STRING, 'label': 'LBFC', 'type': 'number', 'tooltip': 'Loose Ball Fouls Committed'},
  {'field': LOOSE_BALL_FOUL_TYPE_STRING + FOULS_DRAWN_TYPE_STRING, 'label': 'LBFD', 'type': 'number', 'tooltip': 'Loose Ball Fouls Drawn'},
  {'field': OFFENSIVE_FOUL_TYPE_STRING, 'label': 'OffC', 'type': 'number', 'tooltip': 'Non Charge Offensive Fouls Committed'},
  {'field': CHARGE_FOUL_TYPE_STRING, 'label': 'ChC', 'type': 'number', 'tooltip': 'Charges Committed'},
  {'field': OFFENSIVE_FOUL_TYPE_STRING + FOULS_DRAWN_TYPE_STRING, 'label': 'OffD', 'type': 'number', 'tooltip': 'Non Charge Offensive Fouls Drawn'},
  {'field': CHARGE_FOUL_TYPE_STRING + FOULS_DRAWN_TYPE_STRING, 'label': 'ChD', 'type': 'number', 'tooltip': 'Charges Drawn'},
  {'field': BLOCKING_FOULS_STRING, 'label': 'BFC', 'type': 'number', 'tooltip': 'Blocking Fouls Committed'},
  {'field': BLOCKING_FOULS_STRING + DRAWN_STRING, 'label': 'BFD', 'type': 'number', 'tooltip': 'Blocking Fouls Drawn'},
  {'field': CLEAR_PATH_FOUL_TYPE_STRING, 'label': 'CPFC', 'type': 'number', 'tooltip': 'Clear Path Fouls Committed'},
  {'field': TRANSITION_TAKE_TYPE_STRING, 'label': 'TTFC', 'type': 'number', 'tooltip': 'Transition Take Fouls Committed'},
  {'field': TRANSITION_TAKE_TYPE_STRING + FOULS_DRAWN_TYPE_STRING, 'label': 'TTFD', 'type': 'number', 'tooltip': 'Transition Take Fouls Drawn'},
  {'field': DEFENSIVE_3_SECONDS_FOUL_TYPE_STRING, 'label': 'Def3', 'type': 'number', 'tooltip': 'Def. 3 Seconds Technicals'},
  {'field': FOULS_STRING + DRAWN_STRING, 'label': 'FD', 'type': 'number', 'tooltip': 'Fouls Drawn'}
]

const FT_HEADERS = [
  {'field': FTA_STRING, 'label': 'FTA', 'type': 'number'},
  {'field': TECHNICAL_FREE_THROW_STRING, 'label': 'Tech FTA', 'type': 'number', 'tooltip': 'Technical FTA'},
  {'field': TWO_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING, 'label': '2pt SFD', 'type': 'number', 'tooltip': '2pt Shooting Fouls Drawn'},
  {'field': TWO_POINT_AND1_FREE_THROW_STRING, 'label': '2pt And 1s', 'type': 'number'},
  {'field': THREE_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING, 'label': '3pt SFD', 'type': 'number', 'tooltip': '3pt Shooting Fouls Drawn'},
  {'field': THREE_POINT_AND1_FREE_THROW_STRING, 'label': '3pt And 1s', 'type': 'number'},
  {'field': NON_SHOOTING_STRING + FOULS_STRING + DRAWN_STRING, 'label': 'Non Shooting', 'type': 'number', 'tooltip': 'Non Shooting Fouls That Resulted in FTs'},
  {'field': SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'label': 'SFD Rate', 'type': 'percentage', 'tooltip': 'Shooting Fouls Drawn Rate: (Shooting Fouls Drawn / (FGA + Non-And1 Shooting Fouls Drawn))'},
  {'field': TWO_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'label': '2pt SFD Rate', 'type': 'percentage', 'tooltip': '2pt Shooting Fouls Drawn Rate: (2pt Shooting Fouls Drawn / (FG2A + Non-And1 2pt Shooting Fouls Drawn))'},
  {'field': THREE_POINT_STRING + SHOOTING_FOULS_STRING + DRAWN_STRING + PCT_STRING, 'label': '3pt SFD Rate', 'type': 'percentage', 'tooltip': '3pt Shooting Fouls Drawn Rate: (3pt Shooting Fouls Drawn / (FG3A + Non-And1 3pt Shooting Fouls Drawn))'}
]

const MISC_HEADERS = [
  {'field': BLOCKS_STRING, 'label': 'Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + TWOS_STRING, 'label': '2pt Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + THREES_STRING, 'label': '3pt Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + AT_RIM_STRING, 'label': 'Rim Blocks', 'type': 'number', 'tooltip': 'At Rim Blocks'},
  {'field': BLOCKED_STRING + SHORT_MID_RANGE_STRING, 'label': 'SMR Blocks', 'type': 'number', 'tooltip': 'Short Mid Range (4-14ft) Blocks'},
  {'field': BLOCKED_STRING + LONG_MID_RANGE_STRING, 'label': 'LMR Blocks', 'type': 'number', 'tooltip': 'Long Mid Range (14ft - 3pt line) Blocks'},
  {'field': BLOCKED_STRING + CORNER_3_STRING, 'label': 'C3 Blocks', 'type': 'number', 'tooltip': 'Corner 3 Blocks'},
  {'field': BLOCKED_STRING + ARC_3_STRING, 'label': 'AB3 Blocks', 'type': 'number', 'tooltip': 'Above the Break 3 Blocks'},
  {'field': RECOVERED_STRING + BLOCKS_STRING, 'label': 'BLK REC', 'type': 'number', 'tooltip': 'Blocks Recovered By Own Team'},
  {'field': BLOCKS_STRING + RECOVERED_STRING + PCT_STRING, 'label': 'BLK REC%', 'type': 'percentage', 'tooltip': 'Blocks Recovered %'},
  {'field': STEALS_STRING, 'label': 'Steals', 'type': 'number'},
  {'field': LOST_BALL_STEAL_STRING, 'label': 'Lost Ball Steals', 'type': 'number'},
  {'field': BAD_PASS_STEAL_STRING, 'label': 'Bad Pass Steals', 'type': 'number'},
  {'field': DEFENSIVE_GOALTENDING_STRING, 'label': 'Goaltending Violations', 'type': 'number'}
]

const PLAYER_MISC_HEADERS = [
  {'field': PLUS_MINUS_STRING, 'label': 'P/M', 'type': 'number', 'tooltip': 'On Court Plus Minus'},
  {'field': ON_STRING + OFF_RTG_STRING, 'label': 'OffRtg - On', 'type': 'decimal', 'tooltip': "Team's OffRtg with Player On"},
  {'field': ON_STRING + DEF_RTG_STRING, 'label': 'DefRtg - On', 'type': 'decimal', 'tooltip': "Team's DefRtg with Player On"},
  {'field': FIRST_CHANCE_STRING + POINTS_STRING, 'label': 'First Chance Points', 'type': 'number', 'tooltip': 'Points Scored minus Second Chance Points Scored'},
  {'field': THREE_POINT_STRING + OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDED_STRING + PCT_STRING, 'label': '3pt Miss OReb%', 'type': 'percentage', 'tooltip': "Percentage of Player's 3pt Misses That Are Offensive Rebounded"},
  {'field': AT_RIM_STRING + OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDED_STRING + PCT_STRING, 'label': 'Rim Miss OReb%', 'type': 'percentage', 'tooltip': "Percentage of Player's At Rim Misses That Are Offensive Rebounded"},
  {'field': SHORT_MID_RANGE_STRING + OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDED_STRING + PCT_STRING, 'label': 'SMR Miss OReb%', 'type': 'percentage', 'tooltip': "Percentage of Players' Short Mid-Range Misses That Are Offensive Rebounded"},
  {'field': LONG_MID_RANGE_STRING + OFFENSIVE_ABBREVIATION_PREFIX + REBOUNDED_STRING + PCT_STRING, 'label': 'LMR Miss OReb%', 'type': 'percentage', 'tooltip': "Percentage of Player's Long Mid-Range Misses That Are Offensive Rebounded"}
]

const TEAM_MISC_HEADERS = [
  {'field': PACE_STRING, 'label': 'Pace', 'type': 'decimal'},
  {'field': SECONDS_STRING + PER_POSSESSION_STRING + OFFENSIVE_ABBREVIATION_PREFIX, 'label': 'OPace', 'type': 'decimal', 'tooltip': 'Seconds Per Possession - Offense'},
  {'field': SECONDS_STRING + PER_POSSESSION_STRING + DEFENSIVE_ABBREVIATION_PREFIX, 'label': 'DPace', 'type': 'decimal', 'tooltip': 'Seconds Per Possession - Defense'},
  {'field': SECONDS_STRING + EXCLUDING_OREBS_STRING + PER_POSSESSION_STRING + OFFENSIVE_ABBREVIATION_PREFIX, 'label': 'OPace (Excluding Second Chances)', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Excluding Second Chance Time - Offense'},
  {'field': SECONDS_STRING + EXCLUDING_OREBS_STRING + PER_POSSESSION_STRING + DEFENSIVE_ABBREVIATION_PREFIX, 'label': 'DPace (Excluding Second Chances)', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Excluding Second Chance Time - Defense'},
  {'field': FIRST_CHANCE_STRING + POINTS_STRING, 'label': 'First Chance Points', 'type': 'number', 'tooltip': 'Points Scored minus Second Chance Points Scored'}
]

const LINEUP_MISC_HEADERS = [
  {'field': PACE_STRING, 'label': 'Pace', 'type': 'decimal'},
  {'field': SECONDS_STRING + PER_POSSESSION_STRING + OFFENSIVE_ABBREVIATION_PREFIX, 'label': 'OPace', 'type': 'decimal', 'tooltip': 'Seconds Per Possession - Offense'},
  {'field': SECONDS_STRING + PER_POSSESSION_STRING + DEFENSIVE_ABBREVIATION_PREFIX, 'label': 'DPace', 'type': 'decimal', 'tooltip': 'Seconds Per Possession - Defense'},
  {'field': SECONDS_STRING + EXCLUDING_OREBS_STRING + PER_POSSESSION_STRING + OFFENSIVE_ABBREVIATION_PREFIX, 'label': 'OPace (Excluding Second Chances)', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Excluding Second Chance Time - Offense'},
  {'field': SECONDS_STRING + EXCLUDING_OREBS_STRING + PER_POSSESSION_STRING + DEFENSIVE_ABBREVIATION_PREFIX, 'label': 'DPace (Excluding Second Chances)', 'type': 'decimal', 'tooltip': 'Seconds Per Possession Excluding Second Chance Time - Defense'},
  {'field': FIRST_CHANCE_STRING + POINTS_STRING, 'label': 'First Chance Points', 'type': 'number', 'tooltip': 'Points Scored minus Second Chance Points Scored'}
]

const SHOT_DISTRIBUTION_HEADERS = [
  {'field': SHOT_QUALITY_AVG_STRING, 'label': 'Shot Quality', 'type': 'decimal', 'tooltip': 'Expected eFG model based on location and play context. See link on homepage for more details'},
  {'field': AT_RIM_STRING + FG3A_STRING + FREQUENCY_STRING, 'label': 'Rim or 3 Freq', 'type': 'percentage', 'tooltip': 'Percentage of all shots from either at the rim or 3'},
  {'field': AVG_2PT_SHOT_DISTANCE, 'label': 'Avg 2pt Shot Distance', 'type': 'decimal'},
  {'field': AVG_3PT_SHOT_DISTANCE, 'label': 'Avg 3pt Shot Distance', 'type': 'decimal'},
  {'field': AT_RIM_STRING + FGM_STRING, 'label': 'Rim FGM', 'type': 'number', 'tooltip': 'At Rim FGM'},
  {'field': AT_RIM_STRING + FGA_STRING, 'label': 'Rim FGA', 'type': 'number', 'tooltip': 'At Rim FGA', 'minfilter': true},
  {'field': AT_RIM_STRING + FREQUENCY_STRING, 'label': 'Rim Freq', 'type': 'percentage', 'tooltip': 'At Rim Frequency'},
  {'field': AT_RIM_STRING + ACCURACY_STRING, 'label': 'Rim FG%', 'type': 'percentage', 'tooltip': 'At Rim FG%'},
  {'field': UNBLOCKED_STRING + AT_RIM_STRING + ACCURACY_STRING, 'label': 'Unblocked Rim FG%', 'type': 'percentage', 'tooltip': 'Unblocked At Rim FG%'},
  {'field': AT_RIM_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'Rim %AST', 'type': 'percentage', 'tooltip': 'At Rim % Assisted'},
  {'field': AT_RIM_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of Rim FGAB', 'type': 'percentage', 'tooltip': '% of At Rim FGA Blocked'},
  {'field': SHORT_MID_RANGE_STRING + FGM_STRING, 'label': 'SMR FGM', 'type': 'number', 'tooltip': 'Short Mid Range (4-14ft) FGM'},
  {'field': SHORT_MID_RANGE_STRING + FGA_STRING, 'label': 'SMR FGA', 'type': 'number', 'tooltip': 'Short Mid Range (4-14ft) FGA', 'minfilter': true},
  {'field': SHORT_MID_RANGE_STRING + FREQUENCY_STRING, 'label': 'SMR Freq', 'type': 'percentage', 'tooltip': 'Short Mid Range (4-14ft) Frequency'},
  {'field': SHORT_MID_RANGE_STRING + ACCURACY_STRING, 'label': 'SMR FG%', 'type': 'percentage', 'tooltip': 'Short Mid Range (4-14ft) FG%'},
  {'field': UNBLOCKED_STRING + SHORT_MID_RANGE_STRING + ACCURACY_STRING, 'label': 'Unblocked SMR FG%', 'type': 'percentage', 'tooltip': 'Unblocked Short Mid Range (4-14ft) FG%'},
  {'field': SHORT_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'SMR %AST', 'type': 'percentage', 'tooltip': 'Short Mid Range (4-14ft) % Assisted'},
  {'field': SHORT_MID_RANGE_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of SMR FGAB', 'type': 'percentage', 'tooltip': '% of Short Mid Range (4-14ft) FGA Blocked'},
  {'field': LONG_MID_RANGE_STRING + FGM_STRING, 'label': 'LMR FGM', 'type': 'number', 'tooltip': 'Long Mid Range (14ft - 3pt line) FGM'},
  {'field': LONG_MID_RANGE_STRING + FGA_STRING, 'label': 'LMR FGA', 'type': 'number', 'tooltip': 'Long Mid Range (14ft - 3pt line) FGA', 'minfilter': true},
  {'field': LONG_MID_RANGE_STRING + FREQUENCY_STRING, 'label': 'LMR Freq', 'type': 'percentage', 'tooltip': 'Long Mid Range (14ft - 3pt line) Frequency'},
  {'field': LONG_MID_RANGE_STRING + ACCURACY_STRING, 'label': 'LMR FG%', 'type': 'percentage', 'tooltip': 'Long Mid Range (14ft - 3pt line) FG%'},
  {'field': UNBLOCKED_STRING + LONG_MID_RANGE_STRING + ACCURACY_STRING, 'label': 'Unblocked LMR FG%', 'type': 'percentage', 'tooltip': 'Unblocked Long Mid Range (14ft - 3pt line) FG%'},
  {'field': LONG_MID_RANGE_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'LMR %AST', 'type': 'percentage', 'tooltip': 'Long Mid Range (14ft - 3pt line) % Assisted'},
  {'field': LONG_MID_RANGE_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of LMR FGAB', 'type': 'percentage', 'tooltip': '% of Long Mid Range (14ft - 3pt line) FGA Blocked'},
  {'field': CORNER_3_STRING + FGM_STRING, 'label': 'C3 FGM', 'type': 'number', 'tooltip': 'Corner 3 FGM'},
  {'field': CORNER_3_STRING + FGA_STRING, 'label': 'C3 FGA', 'type': 'number', 'tooltip': 'Corner 3 FGA', 'minfilter': true},
  {'field': CORNER_3_STRING + FREQUENCY_STRING, 'label': 'C3 Freq', 'type': 'percentage', 'tooltip': 'Corner 3 Frequency'},
  {'field': CORNER_3_STRING + ACCURACY_STRING, 'label': 'C3 FG%', 'type': 'percentage', 'tooltip': 'Corner 3 FG%'},
  {'field': UNBLOCKED_STRING + CORNER_3_STRING + ACCURACY_STRING, 'label': 'Unblocked C3 FG%', 'type': 'percentage', 'tooltip': 'Unblocked Corner 3 FG%'},
  {'field': CORNER_3_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'C3 %AST', 'type': 'percentage', 'tooltip': 'Corner 3 % Assisted'},
  {'field': CORNER_3_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of C3 FGAB', 'type': 'percentage', 'tooltip': '% of Corner 3 FGA Blocked'},
  {'field': ARC_3_STRING + FGM_STRING, 'label': 'AB3 FGM', 'type': 'number', 'tooltip': 'Above the Break 3 FGM'},
  {'field': ARC_3_STRING + FGA_STRING, 'label': 'AB3 FGA', 'type': 'number', 'tooltip': 'Above the Break 3 FGA', 'minfilter': true},
  {'field': ARC_3_STRING + FREQUENCY_STRING, 'label': 'AB3 Freq', 'type': 'percentage', 'tooltip': 'Above the Break 3 Frequency'},
  {'field': ARC_3_STRING + ACCURACY_STRING, 'label': 'AB3 FG%', 'type': 'percentage', 'tooltip': 'Above the Break 3 FG%'},
  {'field': UNBLOCKED_STRING + ARC_3_STRING + ACCURACY_STRING, 'label': 'Unblocked AB3 FG%', 'type': 'percentage', 'tooltip': 'Unblocked Above the Break 3 FG%'},
  {'field': ARC_3_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'AB3 %AST', 'type': 'percentage', 'tooltip': 'Above the Break 3 % Assisted'},
  {'field': ARC_3_STRING + PCT_STRING + BLOCKED_STRING, 'label': '% of AB3 FGAB', 'type': 'percentage', 'tooltip': '% of Above the Break FGA Blocked'},
  {'field': NON_HEAVE_STRING + ARC_3_STRING + FGM_STRING, 'label': 'Non-Heave AB3 FGM', 'type': 'number', 'tooltip': 'Non-Heave Above the Break 3 FGM'},
  {'field': NON_HEAVE_STRING + ARC_3_STRING + FGA_STRING, 'label': 'Non-Heave AB3 FGA', 'type': 'number', 'tooltip': 'Non-Heave Above the Break 3 FGA', 'minfilter': true},
  {'field': NON_HEAVE_STRING + ARC_3_STRING + ACCURACY_STRING, 'label': 'Non-Heave AB3 FG%', 'type': 'percentage', 'tooltip': 'Non-Heave Above the Break 3 FG%'},
  {'field': HEAVE_ATTEMPTS_STRING, 'label': 'Heaves', 'type': 'number', 'tooltip': 'Heaves are defined as 40+ feet with <2 seconds remaining'},
  {'field': HEAVE_MAKES_STRING, 'label': 'Heaves Made', 'type': 'number'}
]

const SECOND_CHANCE_HEADERS = [
  {'field': SECOND_CHANCE_STRING + OFFENSIVE_POSSESSION_STRING, 'label': 'Possessions', 'type': 'number'},
  {'field': SECOND_CHANCE_STRING + POINTS_STRING, 'label': 'Pts', 'type': 'number'},
  {'field': SECOND_CHANCE_STRING + POINTS_STRING + PCT_STRING, 'label': 'Pts%', 'type': 'percentage', 'tooltip': 'Percentage of All Points from Second Chances'},
  {'field': SECOND_CHANCE_STRING + FG2M_STRING, 'label': 'FG2M', 'type': 'number'},
  {'field': SECOND_CHANCE_STRING + FG2A_STRING, 'label': 'FG2A', 'type': 'number', 'minfilter': true},
  {'field': SECOND_CHANCE_STRING + FG2_PCT_STRING, 'label': '2pt FG%', 'type': 'percentage'},
  {'field': SECOND_CHANCE_STRING + FG3M_STRING, 'label': 'FG3M', 'type': 'number'},
  {'field': SECOND_CHANCE_STRING + FG3A_STRING, 'label': 'FG3A', 'type': 'number', 'minfilter': true},
  {'field': SECOND_CHANCE_STRING + FG3_PCT_STRING, 'label': '3pt FG%', 'type': 'percentage'},
  {'field': SECOND_CHANCE_STRING + FT_POINTS_STRING, 'label': 'FT Pts', 'type': 'number'},
  {'field': SECOND_CHANCE_STRING + EFG_PCT_STRING, 'label': 'eFG%', 'type': 'percentage'},
  {'field': SECOND_CHANCE_STRING + TS_PCT_STRING, 'label': 'TS%', 'type': 'percentage'},
  {'field': SECOND_CHANCE_STRING + SHOT_QUALITY_AVG_STRING, 'label': 'Shot Quality', 'type': 'decimal', 'tooltip': 'Expected eFG model based on location and play context. See link on homepage for more details'},
  {'field': SECOND_CHANCE_STRING + AT_RIM_STRING + FGM_STRING, 'label': 'Rim FGM', 'type': 'number', 'tooltip': 'At Rim FGM'},
  {'field': SECOND_CHANCE_STRING + AT_RIM_STRING + FGA_STRING, 'label': 'Rim FGA', 'type': 'number', 'tooltip': 'At Rim FGA', 'minfilter': true},
  {'field': SECOND_CHANCE_STRING + AT_RIM_STRING + FREQUENCY_STRING, 'label': 'Rim Freq', 'type': 'percentage', 'tooltip': 'At Rim Frequency'},
  {'field': SECOND_CHANCE_STRING + AT_RIM_STRING + ACCURACY_STRING, 'label': 'Rim FG%', 'type': 'percentage', 'tooltip': 'At Rim FG%'},
  {'field': SECOND_CHANCE_STRING + AT_RIM_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'Rim %AST', 'type': 'percentage', 'tooltip': 'At Rim % Assisted'},
  {'field': SECOND_CHANCE_STRING + CORNER_3_STRING + FGM_STRING, 'label': 'C3 FGM', 'type': 'number', 'tooltip': 'Corner 3 FGM'},
  {'field': SECOND_CHANCE_STRING + CORNER_3_STRING + FGA_STRING, 'label': 'C3 FGA', 'type': 'number', 'tooltip': 'Corner 3 FGA', 'minfilter': true},
  {'field': SECOND_CHANCE_STRING + CORNER_3_STRING + FREQUENCY_STRING, 'label': 'C3 Freq', 'type': 'percentage', 'tooltip': 'Corner 3 Frequency'},
  {'field': SECOND_CHANCE_STRING + CORNER_3_STRING + ACCURACY_STRING, 'label': 'C3 FG%', 'type': 'percentage', 'tooltip': 'Corner 3 FG%'},
  {'field': SECOND_CHANCE_STRING + CORNER_3_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'C3 %AST', 'type': 'percentage', 'tooltip': 'Corner 3 % Assisted'},
  {'field': SECOND_CHANCE_STRING + ARC_3_STRING + FGM_STRING, 'label': 'AB3 FGM', 'type': 'number', 'tooltip': 'Above the Break 3 FGM'},
  {'field': SECOND_CHANCE_STRING + ARC_3_STRING + FGA_STRING, 'label': 'AB3 FGA', 'type': 'number', 'tooltip': 'Above the Break 3 FGA', 'minfilter': true},
  {'field': SECOND_CHANCE_STRING + ARC_3_STRING + FREQUENCY_STRING, 'label': 'AB3 Freq', 'type': 'percentage', 'tooltip': 'Above the Break 3 Frequency'},
  {'field': SECOND_CHANCE_STRING + ARC_3_STRING + ACCURACY_STRING, 'label': 'AB3 FG%', 'type': 'percentage', 'tooltip': 'Above the Break 3 FG%'},
  {'field': SECOND_CHANCE_STRING + ARC_3_STRING + PCT_STRING + ASSISTED_STRING, 'label': 'AB3 %AST', 'type': 'percentage', 'tooltip': 'Above the Break 3 % Assisted'},
  {'field': SECOND_CHANCE_STRING + TURNOVERS_KEY, 'label': 'TOs', 'type': 'number'}
]

const PENALTY_HEADERS = [
  {'field': PENALTY_KEY + OFFENSIVE_POSSESSION_STRING, 'label': 'Possessions', 'type': 'number'},
  {'field': PENALTY_KEY + OFFENSIVE_POSSESSION_STRING + PCT_STRING, 'label': 'Possessions%', 'type': 'percentage', 'tooltip': 'Percentage of All Possessions in Penalty'},
  {'field': PENALTY_KEY + POINTS_STRING, 'label': 'Pts', 'type': 'number'},
  {'field': PENALTY_KEY + POINTS_STRING + PCT_STRING, 'label': 'Pts%', 'type': 'percentage', 'tooltip': 'Percentage of All Points on Possessions in Penalty'},
  {'field': PENALTY_KEY + FG2M_STRING, 'label': 'FG2M', 'type': 'number'},
  {'field': PENALTY_KEY + FG2A_STRING, 'label': 'FG2A', 'type': 'number', 'minfilter': true},
  {'field': PENALTY_KEY + FG2_PCT_STRING, 'label': '2pt FG%', 'type': 'percentage'},
  {'field': PENALTY_KEY + FG3M_STRING, 'label': 'FG3M', 'type': 'number'},
  {'field': PENALTY_KEY + FG3A_STRING, 'label': 'FG3A', 'type': 'number', 'minfilter': true},
  {'field': PENALTY_KEY + FG3_PCT_STRING, 'label': '3pt FG%', 'type': 'percentage'},
  {'field': PENALTY_KEY + FT_POINTS_STRING, 'label': 'FT Pts', 'type': 'number'},
  {'field': PENALTY_KEY + EFG_PCT_STRING, 'label': 'eFG%', 'type': 'percentage'},
  {'field': PENALTY_KEY + TS_PCT_STRING, 'label': 'TS%', 'type': 'percentage'},
  {'field': PENALTY_KEY + SHOT_QUALITY_AVG_STRING, 'label': 'Shot Quality', 'type': 'decimal', 'tooltip': 'Expected eFG model based on location and play context. See link on homepage for more details'},
  {'field': PENALTY_KEY + AT_RIM_STRING + FGM_STRING, 'label': 'Rim FGM', 'type': 'number', 'tooltip': 'At Rim FGM'},
  {'field': PENALTY_KEY + AT_RIM_STRING + FGA_STRING, 'label': 'Rim FGA', 'type': 'number', 'tooltip': 'At Rim FGA', 'minfilter': true},
  {'field': PENALTY_KEY + AT_RIM_STRING + FREQUENCY_STRING, 'label': 'Rim Freq', 'type': 'percentage', 'tooltip': 'At Rim Frequency'},
  {'field': PENALTY_KEY + AT_RIM_STRING + ACCURACY_STRING, 'label': 'Rim FG%', 'type': 'percentage', 'tooltip': 'At Rim FG%'},
  {'field': PENALTY_KEY + CORNER_3_STRING + FGM_STRING, 'label': 'C3 FGM', 'type': 'number', 'tooltip': 'Corner 3 FGM'},
  {'field': PENALTY_KEY + CORNER_3_STRING + FGA_STRING, 'label': 'C3 FGA', 'type': 'number', 'tooltip': 'Corner 3 FGA', 'minfilter': true},
  {'field': PENALTY_KEY + CORNER_3_STRING + FREQUENCY_STRING, 'label': 'C3 Freq', 'type': 'percentage', 'tooltip': 'Corner 3 Frequency'},
  {'field': PENALTY_KEY + CORNER_3_STRING + ACCURACY_STRING, 'label': 'C3 FG%', 'type': 'percentage', 'tooltip': 'Corner 3 FG%'},
  {'field': PENALTY_KEY + ARC_3_STRING + FGM_STRING, 'label': 'AB3 FGM', 'type': 'number', 'tooltip': 'Above the Break 3 FGM'},
  {'field': PENALTY_KEY + ARC_3_STRING + FGA_STRING, 'label': 'AB3 FGA', 'type': 'number', 'tooltip': 'Above the Break 3 FGA', 'minfilter': true},
  {'field': PENALTY_KEY + ARC_3_STRING + FREQUENCY_STRING, 'label': 'AB3 Freq', 'type': 'percentage', 'tooltip': 'Above the Break 3 Frequency'},
  {'field': PENALTY_KEY + ARC_3_STRING + ACCURACY_STRING, 'label': 'AB3 FG%', 'type': 'percentage', 'tooltip': 'Above the Break 3 FG%'},
  {'field': PENALTY_KEY + TURNOVERS_KEY, 'label': 'TOs', 'type': 'number'},
  {'field': PENALTY_POSSESSIONS_EXCLUDING_TAKE_FOUL_FTS, 'label': 'Non-Take Foul Possessions', 'type': 'number', 'tooltip': 'Penalty Possessions Excluding Final Minute Possessions with Take Fouls'},
  {'field': PENALTY_POINTS_EXCLUDING_TAKE_FOUL_FTS, 'label': 'Non-Take Foul Points', 'type': 'number', 'tooltip': 'Penalty Points Excluding Final Minute Possessions with Take Fouls'},
  {'field': NON_SHOOTING_NON_TAKE_PENALTY_FOULS_DRAWN, 'label': 'Non-Shooting Fouls Drawn', 'type': 'number', 'tooltip': 'Non-Shooting Non-Take Fouls Drawn while in penalty'},
  {'field': PENALTY_KEY + DEFENSIVE_POSSESSION_STRING, 'label': 'Def. Possessions', 'type': 'number'},
  {'field': NON_SHOOTING_NON_TAKE_PENALTY_FOULS_COMMITTED, 'label': 'Non-Shooting Fouls', 'type': 'number', 'tooltip': 'Non-Shooting Non-Take Fouls while in penalty'}
]

const NUMBER_OF_FOULS_HEADERS = [
  {'field': 'Period1Fouls2Minutes', 'label': 'Q1 2F', 'tooltip': 'Minutes played in 1st quarter with 2 fouls'},
  {'field': 'Period1Fouls3Minutes', 'label': 'Q1 3F', 'tooltip': 'Minutes played in 1st quarter with 3 fouls'},
  {'field': 'Period2Fouls2Minutes', 'label': 'Q2 2F', 'tooltip': 'Minutes played in 2nd quarter with 2 fouls'},
  {'field': 'Period2Fouls3Minutes', 'label': 'Q2 3F', 'tooltip': 'Minutes played in 2nd quarter with 3 fouls'},
  {'field': 'Period2Fouls4Minutes', 'label': 'Q2 4F', 'tooltip': 'Minutes played in 2nd quarter with 4 fouls'},
  {'field': 'Period3Fouls3Minutes', 'label': 'Q3 3F', 'tooltip': 'Minutes played in 3rd quarter with 3 fouls'},
  {'field': 'Period3Fouls4Minutes', 'label': 'Q3 4F', 'tooltip': 'Minutes played in 3rd quarter with 4 fouls'},
  {'field': 'Period3Fouls5Minutes', 'label': 'Q3 5F', 'tooltip': 'Minutes played in 3rd quarter with 5 fouls'},
  {'field': 'Period4Fouls4Minutes', 'label': 'Q4 4F', 'tooltip': 'Minutes played in 4th quarter with 4 fouls'},
  {'field': 'Period4Fouls5Minutes', 'label': 'Q4 5F', 'tooltip': 'Minutes played in 4th quarter with 5 fouls'},
  {'field': 'PeriodOTFouls4Minutes', 'label': 'OT 4F', 'tooltip': 'Minutes played in overtime with 4 fouls'},
  {'field': 'PeriodOTFouls5Minutes', 'label': 'OT 5F', 'tooltip': 'Minutes played in overtime with 5 fouls'}
]

const NUMBER_OF_FOULS_NUMERIC_HEADERS = [
  {'field': 'Period1Fouls2Minutes', 'label': 'Q1 2F', 'tooltip': 'Minutes played in 1st quarter with 2 fouls', 'type': 'number'},
  {'field': 'Period1Fouls3Minutes', 'label': 'Q1 3F', 'tooltip': 'Minutes played in 1st quarter with 3 fouls', 'type': 'number'},
  {'field': 'Period2Fouls2Minutes', 'label': 'Q2 2F', 'tooltip': 'Minutes played in 2nd quarter with 2 fouls', 'type': 'number'},
  {'field': 'Period2Fouls3Minutes', 'label': 'Q2 3F', 'tooltip': 'Minutes played in 2nd quarter with 3 fouls', 'type': 'number'},
  {'field': 'Period2Fouls4Minutes', 'label': 'Q2 4F', 'tooltip': 'Minutes played in 2nd quarter with 4 fouls', 'type': 'number'},
  {'field': 'Period3Fouls3Minutes', 'label': 'Q3 3F', 'tooltip': 'Minutes played in 3rd quarter with 3 fouls', 'type': 'number'},
  {'field': 'Period3Fouls4Minutes', 'label': 'Q3 4F', 'tooltip': 'Minutes played in 3rd quarter with 4 fouls', 'type': 'number'},
  {'field': 'Period3Fouls5Minutes', 'label': 'Q3 5F', 'tooltip': 'Minutes played in 3rd quarter with 5 fouls', 'type': 'number'},
  {'field': 'Period4Fouls4Minutes', 'label': 'Q4 4F', 'tooltip': 'Minutes played in 4th quarter with 4 fouls', 'type': 'number'},
  {'field': 'Period4Fouls5Minutes', 'label': 'Q4 5F', 'tooltip': 'Minutes played in 4th quarter with 5 fouls', 'type': 'number'},
  {'field': 'PeriodOTFouls4Minutes', 'label': 'OT 4F', 'tooltip': 'Minutes played in overtime with 4 fouls', 'type': 'number'},
  {'field': 'PeriodOTFouls5Minutes', 'label': 'OT 5F', 'tooltip': 'Minutes played in overtime with 5 fouls', 'type': 'number'}
]

const PLAYER_ALL_SEASON_ON_OFF_HEADERS = [
  {'field': ON_STRING + OFF_RTG_STRING, 'label': 'OffRtg - On', 'type': 'decimal'},
  {'field': OFF_STRING + OFF_RTG_STRING, 'label': 'OffRtg - Off', 'type': 'decimal'},
  {'field': OFF_RTG_STRING + 'Diff', 'label': 'On - Off OffRtg', 'type': 'decimal'},
  {'field': ON_STRING + DEF_RTG_STRING, 'label': 'DefRtg - On', 'type': 'decimal'},
  {'field': OFF_STRING + DEF_RTG_STRING, 'label': 'DefRtg - Off', 'type': 'decimal'},
  {'field': DEF_RTG_STRING + 'Diff', 'label': 'On - Off DefRtg', 'type': 'decimal'},
  {'field': ON_STRING + NET_RTG_STRING, 'label': 'NetRtg - On', 'type': 'decimal'},
  {'field': OFF_STRING + NET_RTG_STRING, 'label': 'NetRtg - Off', 'type': 'decimal'},
  {'field': NET_RTG_STRING + 'Diff', 'label': 'On - Off NetRtg', 'type': 'decimal'}
]

const POSSESSION_FINDER_DEF_MISC_PLAYER_HEADERS = [
  {'field': BLOCKS_STRING, 'label': 'Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + TWOS_STRING, 'label': '2pt Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + THREES_STRING, 'label': '3pt Blocks', 'type': 'number'},
  {'field': BLOCKED_STRING + AT_RIM_STRING, 'label': 'Rim Blocks', 'type': 'number', 'tooltip': 'At Rim Blocks'},
  {'field': BLOCKED_STRING + SHORT_MID_RANGE_STRING, 'label': 'SMR Blocks', 'type': 'number', 'tooltip': 'Short Mid Range (4-14ft) Blocks'},
  {'field': BLOCKED_STRING + LONG_MID_RANGE_STRING, 'label': 'LMR Blocks', 'type': 'number', 'tooltip': 'Long Mid Range (14ft - 3pt line) Blocks'},
  {'field': BLOCKED_STRING + CORNER_3_STRING, 'label': 'C3 Blocks', 'type': 'number', 'tooltip': 'Corner 3 Blocks'},
  {'field': BLOCKED_STRING + ARC_3_STRING, 'label': 'AB3 Blocks', 'type': 'number', 'tooltip': 'Above the Break 3 Blocks'},
  {'field': RECOVERED_STRING + BLOCKS_STRING, 'label': 'BLK REC', 'type': 'number', 'tooltip': 'Blocks Recovered By Own Team'},
  {'field': BLOCKS_STRING + RECOVERED_STRING + PCT_STRING, 'label': 'BLK REC%', 'type': 'percentage', 'tooltip': 'Blocks Recovered %'},
  {'field': STEALS_STRING, 'label': 'Steals', 'type': 'number'}
]

export const entityStatsBySeasonHeaders = {
  data () {
    return {
      team_totals_by_season_header: {
        'Scoring': TOTALS_HEADERS.concat(SCORING_HEADERS),
        'Assists': TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': TOTALS_HEADERS.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': TOTALS_HEADERS.concat(PENALTY_HEADERS)
      },
      lineup_totals_by_season_header: {
        'Scoring': TOTALS_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': TOTALS_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': TOTALS_HEADERS.concat(PENALTY_HEADERS)
      },
      player_totals_by_season_header: {
        'Scoring': TOTALS_HEADERS.concat(SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': TOTALS_HEADERS.concat(PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': TOTALS_HEADERS.concat(PENALTY_HEADERS),
        'PlayingTimeByNumberOfFouls': TOTALS_HEADERS.concat(NUMBER_OF_FOULS_NUMERIC_HEADERS),
        'On-Off': TOTALS_HEADERS.concat(PLAYER_ALL_SEASON_ON_OFF_HEADERS)
      }
    }
  }
}

export const wowyHeaders = {
  data () {
    return {
      player_results_header: {
        'Scoring': NAME_HEADER.concat(MINUTES_HEADER, PLUS_MINUS_HEADER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': NAME_HEADER.concat(MINUTES_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(MINUTES_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(MINUTES_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(MINUTES_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(MINUTES_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(MINUTES_HEADER, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(MINUTES_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(MINUTES_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(MINUTES_HEADER, PENALTY_HEADERS)
      },
      player_totals_header: {
        'Scoring': [],
        'Assists': [],
        'Rebounds': [],
        'Turnovers': [],
        'Fouls': [],
        'FTs': [],
        'Misc': [],
        'Shooting': [],
        'SecondChance': [],
        'Penalty': []
      },
      lineups_header: {
        'Scoring': LINEUP_TOTALS_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_TOTALS_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_TOTALS_HEADERS.concat(PENALTY_HEADERS)
      },
      totals_header: {
        'Scoring': MINUTES_HEADER.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': MINUTES_HEADER.concat(ASSISTS_HEADERS),
        'Rebounds': MINUTES_HEADER.concat(REBOUNDS_HEADERS),
        'Turnovers': MINUTES_HEADER.concat(TURNOVERS_HEADERS),
        'Fouls': MINUTES_HEADER.concat(FOULS_HEADERS),
        'FTs': MINUTES_HEADER.concat(FT_HEADERS),
        'Misc': MINUTES_HEADER.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': MINUTES_HEADER.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': MINUTES_HEADER.concat(SECOND_CHANCE_HEADERS),
        'Penalty': MINUTES_HEADER.concat(PENALTY_HEADERS)
      }
    }
  }
}

export const possessionFinderHeaders = {
  data () {
    return {
      team_headers: {
        'Scoring': SCORING_HEADERS,
        'Assists': REBOUNDS_HEADERS,
        'Rebounds': ASSISTS_HEADERS,
        'Turnovers': TURNOVERS_HEADERS,
        'Fouls': FOULS_HEADERS,
        'FTs': FT_HEADERS,
        'Misc': TEAM_MISC_HEADERS.concat(MISC_HEADERS),
        'Shooting': SHOT_DISTRIBUTION_HEADERS,
        'SecondChance': SECOND_CHANCE_HEADERS,
        'Penalty': PENALTY_HEADERS
      },
      player_off_headers: {
        'Scoring': NAME_HEADER.concat(SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': NAME_HEADER.concat(ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(FT_HEADERS),
        'Misc': NAME_HEADER.concat(MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(PENALTY_HEADERS)
      },
      player_def_headers: {
        'Scoring': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'Assists': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'Rebounds': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'Fouls': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'Misc': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER, POSSESSION_FINDER_DEF_MISC_PLAYER_HEADERS),
        'Shooting': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'SecondChance': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER),
        'Penalty': NAME_HEADER.concat(DEFENSIVE_POSSESSION_HEADER)

      },
      possession_headers: [
        {'field': 'GameDate', 'label': 'Date', 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
        {'field': 'Opponent', 'label': 'Opponent'},
        {'field': 'Period', 'label': 'Period', 'type': 'number'},
        {'field': 'StartScoreDifferential', 'label': 'Score Margin', 'type': 'number'},
        {'field': 'StartTime', 'label': 'Start Time'},
        {'field': 'EndTime', 'label': 'End Time'},
        {'field': 'StartType', 'label': 'Possession Start'},
        {'field': FG2M_STRING, 'label': 'FG2M', 'type': 'number'},
        {'field': FG2A_STRING, 'label': 'FG2A', 'type': 'number'},
        {'field': FG3M_STRING, 'label': 'FG3M', 'type': 'number'},
        {'field': FG3A_STRING, 'label': 'FG3A', 'type': 'number'},
        {'field': 'OffensiveRebounds', 'label': 'ORebs', 'type': 'number'},
        {'field': 'Turnovers', 'label': 'Turnovers', 'type': 'number'},
        {'field': 'ShootingFoulsDrawn', 'label': 'Shooting Fouls Drawn', 'type': 'number'},
        {'field': 'NonShootingFoulsThatResultedInFts', 'label': 'Non Shooting Fouls That Resulted in FTs', 'type': 'number'},
        {'field': 'Events', 'label': 'Events'}
      ]
    }
  }
}

export const boxscoreHeaders = {
  data () {
    return {
      player_header: {
        'Scoring': PLAYER_GAME_HEADERS.concat(SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': PLAYER_GAME_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': PLAYER_GAME_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': PLAYER_GAME_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': PLAYER_GAME_HEADERS.concat(FOULS_HEADERS),
        'FTs': PLAYER_GAME_HEADERS.concat(FT_HEADERS),
        'Misc': PLAYER_GAME_HEADERS.concat(MISC_HEADERS),
        'Shooting': PLAYER_GAME_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': PLAYER_GAME_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': PLAYER_GAME_HEADERS.concat(PENALTY_HEADERS)
      },
      lineups_header: {
        'Scoring': LINEUP_GAME_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_GAME_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_GAME_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_GAME_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_GAME_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_GAME_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_GAME_HEADERS.concat(MISC_HEADERS),
        'Shooting': LINEUP_GAME_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_GAME_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_GAME_HEADERS.concat(PENALTY_HEADERS)
      }
    }
  }
}

export const gameLogsHeaders = {
  data () {
    return {
      team_game_logs_header: {
        'Scoring': TEAM_GAME_LOGS_HEADERS.concat(SCORING_HEADERS),
        'Assists': TEAM_GAME_LOGS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': TEAM_GAME_LOGS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': TEAM_GAME_LOGS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': TEAM_GAME_LOGS_HEADERS.concat(FOULS_HEADERS),
        'FTs': TEAM_GAME_LOGS_HEADERS.concat(FT_HEADERS),
        'Misc': TEAM_GAME_LOGS_HEADERS.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': TEAM_GAME_LOGS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': TEAM_GAME_LOGS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': TEAM_GAME_LOGS_HEADERS.concat(PENALTY_HEADERS)
      },
      team_totals_header: {
        'Scoring': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(GAMES_PLAYED_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(GAMES_PLAYED_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(GAMES_PLAYED_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(GAMES_PLAYED_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(GAMES_PLAYED_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(GAMES_PLAYED_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(GAMES_PLAYED_HEADER, PENALTY_HEADERS)
      },
      lineup_game_logs_header: {
        'Scoring': LINEUP_GAME_LOGS_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_GAME_LOGS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_GAME_LOGS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_GAME_LOGS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_GAME_LOGS_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_GAME_LOGS_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_GAME_LOGS_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_GAME_LOGS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_GAME_LOGS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_GAME_LOGS_HEADERS.concat(PENALTY_HEADERS)
      },
      lineup_totals_header: {
        'Scoring': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_TOTALS_NON_FILTERABLE_HEADERS.concat(PENALTY_HEADERS)
      },
      player_game_logs_header: {
        'Scoring': PLAYER_GAME_LOGS_HEADERS.concat(SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': PLAYER_GAME_LOGS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': PLAYER_GAME_LOGS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': PLAYER_GAME_LOGS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': PLAYER_GAME_LOGS_HEADERS.concat(FOULS_HEADERS),
        'FTs': PLAYER_GAME_LOGS_HEADERS.concat(FT_HEADERS),
        'Misc': PLAYER_GAME_LOGS_HEADERS.concat(PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': PLAYER_GAME_LOGS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': PLAYER_GAME_LOGS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': PLAYER_GAME_LOGS_HEADERS.concat(PENALTY_HEADERS),
        'PlayingTimeByNumberOfFouls': PLAYER_GAME_LOGS_HEADERS.concat(NUMBER_OF_FOULS_HEADERS)
      },
      player_totals_header: {
        'Scoring': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, PENALTY_HEADERS),
        'PlayingTimeByNumberOfFouls': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER, NUMBER_OF_FOULS_NUMERIC_HEADERS)
      }
    }
  }
}

export const totalHeaders = {
  data () {
    return {
      team_results_header: {
        'Scoring': NAME_HEADER.concat(SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(FT_HEADERS),
        'Misc': NAME_HEADER.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(PENALTY_HEADERS)
      },
      team_results_start_type_with_starter_state_header: {
        'Scoring': NAME_HEADER.concat(MINUTES_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(MINUTES_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(MINUTES_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(MINUTES_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(MINUTES_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(MINUTES_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(MINUTES_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(MINUTES_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(MINUTES_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(MINUTES_HEADER, PENALTY_HEADERS)
      },
      team_results_start_type_no_starter_state_no_leverage_header: {
        'Scoring': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(GAMES_PLAYED_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(GAMES_PLAYED_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(GAMES_PLAYED_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(GAMES_PLAYED_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(GAMES_PLAYED_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(GAMES_PLAYED_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(GAMES_PLAYED_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(GAMES_PLAYED_HEADER, PENALTY_HEADERS)
      },
      team_results_grouped_by_season_header: {
        'Scoring': NAME_HEADER.concat(SEASON_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(SEASON_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(SEASON_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(SEASON_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(SEASON_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(SEASON_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(SEASON_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(SEASON_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(SEASON_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(SEASON_HEADER, PENALTY_HEADERS)
      },
      team_results_start_type_with_starter_state_grouped_by_season_header: {
        'Scoring': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(SEASON_HEADER, MINUTES_HEADER, PENALTY_HEADERS)
      },
      team_results_start_type_no_starter_state_no_leverage_grouped_by_season_header: {
        'Scoring': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, SCORING_HEADERS),
        'Assists': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(SEASON_HEADER, GAMES_PLAYED_HEADER, PENALTY_HEADERS)
      },
      team_summary_header: {
        'Scoring': SCORING_HEADERS,
        'Assists': ASSISTS_HEADERS,
        'Rebounds': REBOUNDS_HEADERS,
        'Turnovers': TURNOVERS_HEADERS,
        'Fouls': FOULS_HEADERS,
        'FTs': FT_HEADERS,
        'Misc': TEAM_MISC_HEADERS.concat(MISC_HEADERS),
        'Shooting': SHOT_DISTRIBUTION_HEADERS,
        'SecondChance': SECOND_CHANCE_HEADERS,
        'Penalty': PENALTY_HEADERS
      },
      team_summary_start_type_with_starter_state_header: {
        'Scoring': MINUTES_HEADER.concat(SCORING_HEADERS),
        'Assists': MINUTES_HEADER.concat(ASSISTS_HEADERS),
        'Rebounds': MINUTES_HEADER.concat(REBOUNDS_HEADERS),
        'Turnovers': MINUTES_HEADER.concat(TURNOVERS_HEADERS),
        'Fouls': MINUTES_HEADER.concat(FOULS_HEADERS),
        'FTs': MINUTES_HEADER.concat(FT_HEADERS),
        'Misc': MINUTES_HEADER.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': MINUTES_HEADER.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': MINUTES_HEADER.concat(SECOND_CHANCE_HEADERS),
        'Penalty': MINUTES_HEADER.concat(PENALTY_HEADERS)
      },
      team_summary_start_type_no_starter_state_no_leverage_header: {
        'Scoring': GAMES_PLAYED_HEADER.concat(SCORING_HEADERS),
        'Assists': GAMES_PLAYED_HEADER.concat(ASSISTS_HEADERS),
        'Rebounds': GAMES_PLAYED_HEADER.concat(REBOUNDS_HEADERS),
        'Turnovers': GAMES_PLAYED_HEADER.concat(TURNOVERS_HEADERS),
        'Fouls': GAMES_PLAYED_HEADER.concat(FOULS_HEADERS),
        'FTs': GAMES_PLAYED_HEADER.concat(FT_HEADERS),
        'Misc': GAMES_PLAYED_HEADER.concat(TEAM_MISC_HEADERS, MISC_HEADERS),
        'Shooting': GAMES_PLAYED_HEADER.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': GAMES_PLAYED_HEADER.concat(SECOND_CHANCE_HEADERS),
        'Penalty': GAMES_PLAYED_HEADER.concat(PENALTY_HEADERS)
      },
      player_results_header: {
        'Scoring': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, ASSISTS_HEADERS),
        'Rebounds': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, REBOUNDS_HEADERS),
        'Turnovers': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, TURNOVERS_HEADERS),
        'Fouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, FOULS_HEADERS),
        'FTs': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, FT_HEADERS),
        'Misc': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SECOND_CHANCE_HEADERS),
        'Penalty': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, PENALTY_HEADERS)
      },
      player_with_number_of_fouls_results_header: {
        'Scoring': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, ASSISTS_HEADERS),
        'Rebounds': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, REBOUNDS_HEADERS),
        'Turnovers': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, TURNOVERS_HEADERS),
        'Fouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, FOULS_HEADERS),
        'FTs': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, FT_HEADERS),
        'Misc': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, SECOND_CHANCE_HEADERS),
        'Penalty': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, PENALTY_HEADERS),
        'PlayingTimeByNumberOfFouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER_WITH_MINFILTER, NUMBER_OF_FOULS_NUMERIC_HEADERS)
      },
      player_results_with_gp_header: {
        'Scoring': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, ASSISTS_HEADERS),
        'Rebounds': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, REBOUNDS_HEADERS),
        'Turnovers': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, TURNOVERS_HEADERS),
        'Fouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, FOULS_HEADERS),
        'FTs': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, FT_HEADERS),
        'Misc': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SECOND_CHANCE_HEADERS),
        'Penalty': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, PENALTY_HEADERS)
      },
      player_with_number_of_fouls_and_gp_results_header: {
        'Scoring': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, ASSISTS_HEADERS),
        'Rebounds': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, REBOUNDS_HEADERS),
        'Turnovers': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, TURNOVERS_HEADERS),
        'Fouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, FOULS_HEADERS),
        'FTs': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, FT_HEADERS),
        'Misc': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, SECOND_CHANCE_HEADERS),
        'Penalty': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, PENALTY_HEADERS),
        'PlayingTimeByNumberOfFouls': FILTERABLE_NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, GAMES_PLAYED_HEADER, MINUTES_HEADER_WITH_MINFILTER, NUMBER_OF_FOULS_NUMERIC_HEADERS)
      },
      player_summary_header: {
        'Scoring': [],
        'Assists': [],
        'Rebounds': [],
        'Turnovers': [],
        'Fouls': [],
        'FTs': [],
        'Misc': [],
        'Shooting': [],
        'SecondChance': [],
        'Penalty': []
      },
      player_with_number_of_fouls_summary_header: {
        'Scoring': [],
        'Assists': [],
        'Rebounds': [],
        'Turnovers': [],
        'Fouls': [],
        'FTs': [],
        'Misc': [],
        'Shooting': [],
        'SecondChance': [],
        'Penalty': [],
        'PlayingTimeByNumberOfFouls': []
      },
      lineup_totals_no_leverage_header: {
        'Scoring': LINEUP_TOTALS_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_TOTALS_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_TOTALS_HEADERS.concat(PENALTY_HEADERS)
      },
      lineup_totals_with_leverage_header: {
        'Scoring': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_TOTALS_NO_GAMES_PLAYED_HEADERS.concat(PENALTY_HEADERS)
      },
      lineup_summary_header: {
        'Scoring': [],
        'Assists': [],
        'Rebounds': [],
        'Turnovers': [],
        'Fouls': [],
        'FTs': [],
        'Misc': [],
        'Shooting': [],
        'SecondChance': [],
        'Penalty': []
      },
      lineup_player_player_header: {
        'Scoring': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, SCORING_HEADERS, SCORING_PLAYER_ONLY_HEADERS),
        'Assists': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, ASSISTS_HEADERS),
        'Rebounds': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, REBOUNDS_HEADERS),
        'Turnovers': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, TURNOVERS_HEADERS),
        'Fouls': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, FOULS_HEADERS),
        'FTs': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, FT_HEADERS),
        'Misc': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, PLAYER_MISC_HEADERS, MISC_HEADERS),
        'Shooting': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, SECOND_CHANCE_HEADERS),
        'Penalty': NAME_HEADER.concat(TEAM_ABBREVIATION_HEADER, MINUTES_HEADER, PENALTY_HEADERS)
      },
      lineup_player_totals_header: {
        'Scoring': LINEUP_TOTALS_HEADERS.concat(PLUS_MINUS_HEADER, SCORING_HEADERS),
        'Assists': LINEUP_TOTALS_HEADERS.concat(ASSISTS_HEADERS),
        'Rebounds': LINEUP_TOTALS_HEADERS.concat(REBOUNDS_HEADERS),
        'Turnovers': LINEUP_TOTALS_HEADERS.concat(TURNOVERS_HEADERS),
        'Fouls': LINEUP_TOTALS_HEADERS.concat(FOULS_HEADERS),
        'FTs': LINEUP_TOTALS_HEADERS.concat(FT_HEADERS),
        'Misc': LINEUP_TOTALS_HEADERS.concat(LINEUP_MISC_HEADERS, MISC_HEADERS),
        'Shooting': LINEUP_TOTALS_HEADERS.concat(SHOT_DISTRIBUTION_HEADERS),
        'SecondChance': LINEUP_TOTALS_HEADERS.concat(SECOND_CHANCE_HEADERS),
        'Penalty': LINEUP_TOTALS_HEADERS.concat(PENALTY_HEADERS)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/table_headers.js